import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { Tooltip } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getTariffBenefitDescription, getTariffBenefitText, getTariffBenefitUrl } from "../../../../store/blocks/tariffs/benefitSelectors";
import { TariffBenefitsItemContent } from "../TariffBenefitsItemContent";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _TariffBenefitsItem = function _TariffBenefitsItem(props) {
  var content = /*#__PURE__*/React.createElement(TariffBenefitsItemContent, _extends({}, props, {
    "data-t-id": "components-TariffBenefitsItem"
  }));
  var containerRef = props.containerRef,
    text = props.text;
  return /*#__PURE__*/React.createElement("div", {
    className: cn({
      component: text,
      icon: !text
    })
  }, props.description ? /*#__PURE__*/React.createElement(Tooltip, {
    containerRef: containerRef,
    message: props.description,
    position: "right"
  }, content) : content);
};
_TariffBenefitsItem.propTypes = process.env.NODE_ENV !== "production" ? {
  description: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    description: getTariffBenefitDescription(state),
    text: getTariffBenefitText(state),
    url: getTariffBenefitUrl(state)
  };
};
export var TariffBenefitsItem = connect(mapStateToProps)(_TariffBenefitsItem);